import { Svg, Rect } from "react-native-svg";

const UnChecked = (props) => (
  <Svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <Rect x="3" y="3" width="22" height="22" rx="1" stroke="#888C9C" strokeWidth="2" />
  </Svg>
);

export default UnChecked;
